import Vue from 'vue';
import messageInboxComponent from './message.inbox.vue';

const app = new Vue({
    el: '#message-vue-container',
    components: {
        'message-inbox-component': messageInboxComponent
    }
});


